module.exports = __webpack_public_path__ + "static/media/zola-registry-logo-white.efc7b64d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/zola-registry-logo-white.svg
// module id = 3843
// module chunks = 68